import { STATIC_FIELDS } from '../pages/Forms/Constants';

export const getIsStaticForm = (form) =>
  form?.field_settings
    ?.find((page) => page.pageName === 'main-form')
    ?.fields.every((field) =>
      STATIC_FIELDS.includes(field.name.toLowerCase())
    ) || false;
